import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import * as LucideIcons from "lucide-react";
import { ArrowLeft, FileText } from "lucide-react";
import { toast } from "sonner";
import DynamicForm from "@/components/DynamicForm";

export default function RecipeDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [recipe, setRecipe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get(`/recipes/${slug}`)
      .then((res) => setRecipe(res.data))
      .catch(() => toast.error("Ricetta non trovata"))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="space-y-4 max-w-3xl">
        <div className="adr-skeleton h-8 w-2/3" />
        <div className="adr-skeleton h-4 w-1/2" />
        <div className="adr-skeleton h-72 w-full" />
      </div>
    );
  }

  if (!recipe) return null;

  const Icon = LucideIcons[recipe.icon_name] || FileText;
  const fields = recipe.input_schema?.fields || [];

  const submit = async (values) => {
    try {
      const { data } = await api.post("/jobs", { recipe_slug: recipe.slug, inputs: values });
      toast.success("Lavoro avviato");
      navigate(`/lavori/${data.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore avvio lavoro");
    }
  };

  return (
    <div className="max-w-3xl">
      <Link to="/catalogo" className="inline-flex items-center gap-1.5 text-sm text-[#555555] hover:text-[#0F3D6B] mb-6 transition-colors" data-testid="back-to-catalogo">
        <ArrowLeft className="w-4 h-4" />
        Torna al catalogo
      </Link>

      <div className="flex items-start gap-4 mb-6">
        <div className="w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "rgba(15,61,107,0.08)" }}>
          <Icon className="w-7 h-7" style={{ color: "#0F3D6B" }} strokeWidth={1.5} />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="adr-badge capitalize" style={{ background: "rgba(15,61,107,0.08)", color: "#0F3D6B" }}>
              {recipe.category}
            </span>
            <span className="adr-badge capitalize" style={{ background: "rgba(85,85,85,0.1)", color: "#555555" }}>
              {recipe.difficulty}
            </span>
          </div>
          <h1 className="serif text-3xl font-semibold tracking-tight text-[#1A1A1A] leading-tight mb-2">
            {recipe.name_it}
          </h1>
          <p className="text-[#555555]">{recipe.description_it}</p>
        </div>
      </div>

      <div className="adr-card p-6 sm:p-8" data-testid="recipe-form-card">
        <div className="adr-overline mb-4">Compila e avvia</div>
        <DynamicForm fields={fields} onSubmit={submit} submitLabel="Avvia ricetta" />
      </div>

      <div className="text-xs text-[#555555] mt-6 leading-relaxed">
        Il documento generato è una bozza prodotta da AI. Rivedi e valida il contenuto prima dell'utilizzo ufficiale.
      </div>
    </div>
  );
}
